import * as React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createOptimizedQueryClient } from '@/lib/react-query-config';

interface OptimizedQueryProviderProps {
  children: React.ReactNode;
}

export const OptimizedQueryProvider = ({ children }: OptimizedQueryProviderProps) => {
  // Use our centralized optimized query client
  const queryClient = React.useMemo(() => createOptimizedQueryClient(), []);
  

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};